import React, { useState } from "react";
import { Button, Col, Divider, Form, message, Modal, Row, Typography } from "antd";
import { CloseOutlined } from '@ant-design/icons';
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import { useAppDispatch, useAppSelector } from "../../../shared/hooks/redux";
import { setIsEditPhoneModalOpen } from "../phone-confirmation.slice";
import { saudiMobilePattern, removeNoneNumeric } from "../../../shared/utils/helper";
import "react-phone-input-2/lib/style.css";
import { postEditLead } from "../phone-confirmation.model";


function EditPhoneModal() {
    const [phoneNumber, setPhoneNumber] = useState<any>("+966");
    const { isEditPhoneModalOpen, editingLead } = useAppSelector(({ PhoneConfirmation }) => PhoneConfirmation);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const [form] = Form.useForm();
    function onClose() {
        dispatch(setIsEditPhoneModalOpen(false));
    }
    const onNumberChange = (e: any) => {
        if (e?.target?.value?.length <= 4) {
            setPhoneNumber('+966');
            form.setFieldsValue({ captain_mobile: '966' });
            return
        }
        let formattedValue: any = e?.target?.value?.replace("+966", "");
        formattedValue = removeNoneNumeric(formattedValue);
        if (formattedValue.replaceAll(" ", "")?.length >= 10) {
            return
        }
        let str: any = formattedValue.split(" ").join("").split("");
        const formatted: any = [];
        while (str.length) {
            for (let i = 0; i < 3 && str.length; i++) {
                formatted.push(str.shift());
            }
            if (str.length) formatted.push(" ");
        }
        setPhoneNumber("+966 " + formatted.join(""));
        form.setFieldsValue({ captain_mobile: "966" + formatted.join("").replaceAll(" ", "") });
    }
    function onSubmit(values: any) {
        try {
            dispatch(postEditLead(values));
        } catch (error) {
            message.error(t("Error while editing phone number please reach the technical support with code: UL1"));
        }
    }
    return (
        <Modal
            open={isEditPhoneModalOpen}
            onCancel={onClose}
            centered={true}
            closable={false}
            footer={null}
            destroyOnClose={true}
        >
            <Row align={"top"} justify="center" className="LedReg_Result" gutter={[0, 32]}>
                <Col span={24} className="CenterText">
                    <Row align={"middle"} justify={"space-between"}>
                        <Col>
                            <Button
                                className="modal-close-btn" icon={<CloseOutlined />}
                                onClick={onClose}
                            />
                        </Col>
                        <Col>
                            <Typography.Title level={4} style={{ margin: 0 }}>{t("Edit phone number")}</Typography.Title>
                        </Col>
                        <Col></Col>
                    </Row>
                    <Divider style={{ marginTop: 16, marginBottom: 0 }} />
                </Col>
                <Col span={24}>
                    <Form
                        form={form}
                        onFinish={onSubmit}
                        initialValues={{}}
                    >
                        <Form.Item
                            name={"captain_mobile"}
                            labelCol={{ span: 24 }}
                            label={t("Phone Number")}
                            rules={[
                                { required: true, message: t("Phone number is required") },
                                { pattern: saudiMobilePattern, message: t("Please enter a valid phone number") }
                            ]}
                            className={"form-item-mobile-field"}
                        >
                            <PhoneInput
                                inputStyle={{
                                    width: '100%',
                                    height: '48px',
                                    backgroundColor: '#f6f6f6',
                                    border: '1px solid #f6f6f6',
                                    borderColor: '#f6f6f6',
                                    direction: 'ltr',
                                }}
                                inputProps={{
                                    type: "tel",
                                    inputMode: "numeric",
                                    onChange: onNumberChange,
                                    value: phoneNumber,
                                    autoFocus: true
                                }}
                                specialLabel=" "
                                country={"sa"}
                                onlyCountries={["sa"]}
                                countryCodeEditable={false}
                                disableDropdown={true}
                                buttonStyle={{ borderColor: '#dfecf7', borderBottomLeftRadius: 5, borderTopLeftRadius: 5, backgroundColor: '#f6f6f6' }}
                            />
                        </Form.Item>
                    </Form>
                </Col>
                <Col span={24}><Divider style={{ margin: 0 }} /></Col>
                <Col span={24}>
                    <Button
                        loading={editingLead} onClick={() => form.submit()}
                        htmlType="submit" block type="primary"
                    >
                        {t("Confirm")}
                    </Button>
                </Col>
            </Row>
        </Modal>
    );
}

export default EditPhoneModal;